import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  doGetCompanies,
  doGetCompany,
  doCreateCompany,
  doUpdateCompany,
  doRemoveCompany,
  doListPaymentMethods,
} from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('company/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('company/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('company/') && action.type.endsWith('/rejected');
};

const companiesAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const companySlice = createSlice({
  name: 'company',
  initialState: {
    action: null,
    isFetching: false,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
    companyDetail: null,
    paymentMethods: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetCompanies.pending, (state) => {
      state.action = 'getall';
      state.companyDetail = null;
      state.status = 'loading';
    });
    builder.addCase(doGetCompanies.fulfilled, (state, action) => {
      const { items, total, page, take } = action.payload;
      state.status = 'succeeded';
      state.metadata = { totalItems: total, page, take };
      companiesAdapter.setAll(state, items);
    });
    builder.addCase(doGetCompanies.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doGetCompany.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetCompany.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.companyDetail = action.payload;
    });
    builder.addCase(doGetCompany.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreateCompany.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreateCompany.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreateCompany.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdateCompany.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdateCompany.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdateCompany.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doRemoveCompany.pending, (state) => {
      state.action = 'remove';
      state.status = 'loading';
    });
    builder.addCase(doRemoveCompany.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doRemoveCompany.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doListPaymentMethods.fulfilled, (state, action) => {
      state.paymentMethods = action.payload.paymentMethods || [];
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllCompanies,
  selectById: selectCompanyById,
  selectIds: selectCompanyIds,
} = companiesAdapter.getSelectors((state) => state.company);
const { reducer: companyReducer } = companySlice;
export default companyReducer;
